/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { forwardRef } from 'react';
import { MenuItemLink } from 'react-admin';
import ExitIcon from '@material-ui/icons/PowerSettingsNew';

import AuthService from '../providers/auth-service';

const LogoutButton = forwardRef((props, ref) => {
  const handleClick = () => AuthService.logout();
  return (
    <MenuItemLink
      ref={ref}
      to="/login"
      primaryText="Logout"
      leftIcon={<ExitIcon />}
      onClick={handleClick}
    />
  );
});

export default LogoutButton;
